import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { Aed } from "../../../common/Money";

/* What the order costs, and the two ways to pay for it. */
export const OrderSummaryCard = ({
  summary,
  reportMode,
  onPay,
  onUseCredit,
  showCredit = false,
  creditsLeft = 0,
  ordering = false,
  className = "",
}) => (
  <div className={cn("flex flex-col gap-4", className)}>
    <section
      aria-labelledby="owp-price-heading"
      className="rounded-[14px] border border-[var(--line)] bg-white p-4 sm:p-6"
    >
      <h2
        id="owp-price-heading"
        className="m-0 text-[15px] font-bold text-[var(--ink)] font-sans"
      >
        Price details
      </h2>

      <dl className="m-0 mt-3.5 flex flex-col gap-2.5">
        <div className="flex items-center justify-between gap-3">
          <dt className="text-[13px] text-[var(--muted)] font-sans">Subtotal</dt>
          <dd className="m-0 text-[13.5px] font-semibold text-[var(--ink)] font-sans">
            <Aed value={summary.subtotal} />
          </dd>
        </div>

        {reportMode === "member" && (
          <div className="flex items-center justify-between gap-3">
            <dt className="text-[13px] text-[var(--muted)] font-sans">
              Member rate (10% off)
            </dt>
            <dd className="m-0 text-[13.5px] font-semibold text-[var(--success)] font-sans">
              applied
            </dd>
          </div>
        )}

        <div className="flex items-center justify-between gap-3">
          <dt className="text-[13px] text-[var(--muted)] font-sans">VAT</dt>
          <dd className="m-0 text-[13.5px] text-[var(--ink-2)] font-sans">excluded</dd>
        </div>
      </dl>

      <div className="mt-3.5 border-t border-[var(--line)] pt-3.5">
        <div className="flex items-center justify-between gap-3">
          <span className="text-[13.5px] font-bold text-[var(--ink)] font-sans">
            Total (excl. VAT)
          </span>
          <span className="text-[16px] font-bold text-[var(--ink)] font-sans">
            <Aed value={summary.subtotal} />
          </span>
        </div>
        <p className="m-0 mt-1 text-[11.5px] text-[var(--muted)] font-sans">
          VAT is added at the secure checkout.
        </p>
      </div>

      <Button variant="coralSolid" className="mt-4 w-full" onClick={onPay}>
        Pay
      </Button>
    </section>

    {/* Transcribed: the credit panel is offered only when there is a credit or
        an enterprise balance to spend. */}
    {showCredit && (
      <>
        <div className="flex items-center gap-3" aria-hidden="true">
          <span className="h-px flex-1 bg-[var(--line)]" />
          <span className="text-[11px] font-bold uppercase tracking-[.08em] text-[var(--muted)] font-sans">
            or
          </span>
          <span className="h-px flex-1 bg-[var(--line)]" />
        </div>

        <section className="rounded-[14px] bg-[var(--navy)] p-4 sm:p-6">
          <h2 className="m-0 text-[15px] font-bold text-white font-sans">
            Use your credit
          </h2>
          <p className="m-0 mt-1.5 text-[13px] leading-[1.55] text-white/70 font-sans">
            Use 1 credit to request this business.
            {creditsLeft > 0 && (
              <>
                {" "}
                You have {creditsLeft} {creditsLeft === 1 ? "credit" : "credits"} left.
              </>
            )}
          </p>
          <Button
            variant="onDark"
            className="mt-3.5 w-full"
            disabled={ordering}
            onClick={onUseCredit}
          >
            {ordering ? "Placing the order…" : "Use credit"}
          </Button>
        </section>
      </>
    )}
  </div>
);

export default OrderSummaryCard;
